import './ReportEditModal.scss'

import { Modal } from '../Modal'
import Button from '../Button'

import { GridBlocksEnum, defaultConfig, noRender, CommentsForm, ReportBlockComments, CustomChartForm, ReportBlockBarChart } from './blocks'

import { useEffect, useMemo, useState } from 'react'

// Forms by block type.
const modalFormComponents = {
  [GridBlocksEnum.CUSTOM_CHART]: CustomChartForm,
  [GridBlocksEnum.COMMENTS]: CommentsForm
}

const modalPreviewComponents = {
  [GridBlocksEnum.COMMENTS]: ReportBlockComments,
  [GridBlocksEnum.CUSTOM_CHART]: ReportBlockBarChart
}

/**
 * Shows an edit form by block type and handles the update
 * @param {*} param0
 * @returns
 */
export default function ReportEditModal({ controls, block, getData = () => {}, onSubmit = (block) => {}, onAfterClose = () => {}, formatToDate = (date) => {}, context }) {
  // Dynamically resolve form based on type.
  const FormByType = useMemo(() => {
    return modalFormComponents[block.type]
  }, [block])

  // Dynamically resolve preview/block based on type.
  const PreviewType = useMemo(() => {
    return modalPreviewComponents[block.type]
  }, [block])

  // Config form state.
  const [config, setConfig] = useState(structuredClone(block.config) || defaultConfig(block.type, context))

  // Dep data for config form, call once on start.
  const [formData, setFormData] = useState(null)

  const [blockLoadingState, setBlockLoadingState] = useState(false)

  // This will get updated with the config data from the UI
  const [content, setContent] = useState({})

  // Fetch form data.
  useEffect(() => {
    let active = true
    const data = async () => {
      const formType = `SETTING_${block.type}` //?
      const formDataSettings = await getData(formType)

      if (active) {
        setFormData(formDataSettings)
      }
    }
    data()
    return () => {
      active = false
    }
  }, [block.type, getData])

  // set static config
  useEffect(() => {
    let active = true
    const data = async () => {
      setBlockLoadingState(true)
      // Refresh the block data.
      const data = await getData(block.type, config)
      setBlockLoadingState(false)
      if (active) {
        setContent({ ...data })
      }
    }
    data()
    return () => {
      active = false
    }
  }, [config, block, getData])

  const noContent = noRender(block.type, config)

  return (
    <>
      {!content || !formData ? (
        <div></div>
      ) : (
        <Modal
          title={`${block?.created ? 'Edit' : 'Add'} a block.`}
          controls={controls}
          plain={true}
          showControls={noContent}
          size='rb'
          buttons={
            <Button
              disabled={!noContent}
              onClick={() => {
                onSubmit({
                  ...block,
                  content,
                  config
                })
                controls.close()
              }}
            >
              {'Save'}
            </Button>
          }
          afterClose={onAfterClose}
        >
          <section className='report-edit-modal-flex side-by-side'>
            <FormByType
              loading={blockLoadingState}
              formData={formData}
              block={content}
              setBlock={setContent}
              config={config}
              setConfig={setConfig}
              module={context?.name}
              context={context}
            />
            <PreviewType loading={blockLoadingState} config={config} content={content} />
          </section>
        </Modal>
      )}
    </>
  )
}

export { ReportEditModal }
